import {
    Component,
    OnInit,
    ElementRef,
    ViewChild,
    Input,
    Output,
    EventEmitter,
    HostBinding,
    OnDestroy,
    OnChanges,
    SimpleChanges,
    AfterViewInit,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
    Injector,
} from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { Observable, Subscription } from 'rxjs';
import { uiHelper } from '~/helpers/ui.helper';
import { GetOddData } from '~/modules/getOddData';
import { GetOddDataAll } from '~/modules/getOddData.all';
import { OddConstant } from '~/constant/odd.constant';
import { AppComponentBase } from '../../../shared/app-component-base';

declare let SIR: any;
declare let $;
declare let SetLanguage: any;

@Component({
    selector: '.uniqueRow',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './match.row.html',
})
export class MatchRow extends AppComponentBase implements OnInit, OnDestroy, AfterViewInit {
    @Input() fixtureItem: any;
    @Input() indexOfItem: any;
    @Input() IndexOdd: any;

    @Input() typeOfList: string;
    @Input() isScoreBox = false;

    // todo maybe move to constants
    timeStatu: number[] = [3];

    allOdds = [];
    @Input() isExpandShow = false;
    @Output() expandNotifier = new EventEmitter();

    ___oddType_LIVE_Listener: Subscription;
    ___oddType_PRE_Listener: Subscription;
    __sportEnum_Listener: Subscription;

    @HostBinding('class')
    get hostClasses(): string {
        return ['uniqueRow', this.typeOfList].join(' ');
    }

    constructor(
        public tournamentsService: TournamentsService,
        private _uiHelper: uiHelper,
        public _GD: GetOddData,
        public _GDAll: GetOddDataAll,
        public _oddConstant: OddConstant,
        private cd: ChangeDetectorRef,
        private _injector: Injector,
    ) {
        super(_injector);
    }

    oddTypeList: string[] = ['RoM', 'OU', 'NG'];
    oddValues = [{}, {}, {}];
    oddValues2nd = [{}, {}, {}];
    liveActionData = {
        '1': {
            color: 'orange',
            image: '1',
        },
        '2': {
            color: 'red',
            image: '2',
        },
        '4': {
            color: 'orange',
            image: '1',
        },
        '5': {
            color: 'orange',
            image: '1',
        },
        '6': {
            color: 'red',
            image: '2',
        },
        '7': {
            color: 'red',
            image: '2',
        },
        '8': {
            color: 'orange',
            image: '3',
        },
        '9': {
            color: 'orange',
            image: '3',
        },
        '10': {
            color: 'orange',
            image: '3',
        },
    };

    // 5 Tennis, 20 Volleyball => Bunlarda TimeStatuColor gösteriliyor. ( Setler )
    sportEnum = 1;

    ngOnInit() {
        if (this.typeOfList === 'live') {
            this.oddTypeList = this._uiHelper.oddType_LIVE;
            this.___oddType_LIVE_Listener = this._uiHelper.oddType_LIVE_Listener.subscribe(x => {
                this.oddTypeList = x;
                this.getOdds();
            });
        } else if (this.typeOfList === 'pre') {
            this.oddTypeList = this._uiHelper.oddType_PRE;

            this.___oddType_PRE_Listener = this._uiHelper.oddType_PRE_Listener.subscribe(x => {
                this.oddTypeList = x;
                this.getOdds();
            });
        }

        this.getOdds();

        this.sportEnum = this._uiHelper.sportEnum;
        this.__sportEnum_Listener = this._uiHelper.sportEnum_Listener.subscribe(x => {
            this.sportEnum = x;
            this.cd.detectChanges();
        });
    }

    ngAfterViewInit() {}

    ngOnDestroy(): void {
        this.cd.detach();

        if (this.___oddType_PRE_Listener) {
            this.___oddType_PRE_Listener.unsubscribe();
        }

        if (this.___oddType_LIVE_Listener) {
            this.___oddType_LIVE_Listener.unsubscribe();
        }
        if (this.__sportEnum_Listener) {
            this.__sportEnum_Listener.unsubscribe();
        }
        //console.log('ONDESTROY');
    }

    getOdds() {
        try {
            this.oddValues = this._GD.get(this.typeOfList, this.fixtureItem.MatchId, this.oddTypeList);
            if (this.typeOfList === 'live') {
                this.oddValues2nd = this._GD.get(this.typeOfList, this.fixtureItem.MatchId, this.oddTypeList, true);
            }
            this.cd.detectChanges();
        } catch (e) {
            console.warn(e);
        }
    }

    getRowStatus() {
        return this.timeStatu.find(x => x == this.fixtureItem.TimeStatu) ? 'statuBlue' : '';
    }

    getLiveActionText(text) {
        let _text = text;
        _text = _text.replace(/\bT1\b/gi, this.fixtureItem.HomeTeam);
        _text = _text.replace(/\bT2\b/gi, this.fixtureItem.AwayTeam);
        return _text;
    }

    getLiveActionColorImage(e) {
        return this.liveActionData[e];
    }

    //deprecated
    //clickOdd(oddId) {

    //  this.tournamentsService.addOdd(oddId, $('input[name="__RequestVerificationToken"]').val());
    //  this.tournamentsService.matchtimeScore = "UpComing";
    //}

    getExpandData() {
        this.allOdds = this._GDAll.get(this.typeOfList, this.fixtureItem.MatchId);
    }

    expandNotifierHandler() {
        this.expandNotifier.emit(this.fixtureItem.MatchId);
    }

    // todo will remove
    getBgColorEOU(i) {
        if (i % 2 == 0) {
            return '#1C1C1C';
        } else {
            return '#404040';
        }
    }

    // todo will remove
    getBgColorTGS(i) {
        if (i % 2 == 0) {
            return '#323232';
        } else {
            return '#525252';
        }
    }

    // Kırmızı Kartlar için Eski Yöntem Kapatıldı ( 23.09.2021 )
    // getCard(eventID, isHome) {
    //     const cardType = isHome ? 'HomeTeamRed' : 'AwayTeamRed';
    //     if (this.tournamentsService._cardList != null) {
    //         const card = this.tournamentsService._cardList.find(s => s.EventId == eventID);
    //         if (card) {
    //             return card[cardType];
    //         } else {
    //             return '0';
    //         }
    //     }
    // }

    liveActionView(fixture, isScore) {
        if (!isScore) {
            return false;
        }
        return (
            fixture.BetStatus == 3 &&
            (fixture.BetReasonId == 1 ||
                fixture.BetReasonId == 10 ||
                fixture.BetReasonId == 2 ||
                fixture.BetReasonId == 4 ||
                fixture.BetReasonId == 5 ||
                fixture.BetReasonId == 6 ||
                fixture.BetReasonId == 7 ||
                fixture.BetReasonId == 8 ||
                fixture.BetReasonId == 9)
        );
    }

    OpenStandingsModal(fixtureItem) {
        console.log('---fixtureItem--', fixtureItem);

        this._uiHelper.setStatisticModalParameter(fixtureItem.BetradarMatchId);
        // $('#Standings_Modal').modal('show');
        $('#Standings_Modal')
            .modal({
                detachable: false,
            })
            .modal('show');
    }

    OpenLiveTrackerModal(fixtureItem) {
        this._uiHelper.setLiveTrackerModalParameter(fixtureItem.BetradarMatchId);
        let thiss = this;
        let timeFunc;
        $('#Livetracker_Modal')
            .modal({
                detachable: false,

                onShow: function() {
                    timeFunc = setTimeout(() => {
                        $('#Livetracker_Modal').modal('hide');
                    }, 180000);
                },

                onHidden: function() {
                    clearTimeout(timeFunc);
                    thiss._uiHelper.LivetrackerModalClose(true);
                },
            })
            .modal('show');
    }
}
